{
  "familyId": "GET-GROOT-POS",
  "questions": [
    {
      "id": "GET-GROOT-POS-001",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "multiple_choice",
      "question": "Wat is de waarde van de 5 in het getal 5.230?",
      "options": ["5.000","500","50","5"],
      "correctAnswer": 0,
      "conceptId": "place_value",
      "variantIndex": 1,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2 },
      "supportAids": [{"type":"placeValueBlocks","showWhen":"wrong","data":{"thousands":5,"hundreds":2,"tens":3,"ones":0,"highlightColumn":"thousands","showLabels":true,"showTotal":true}}],
      "group": 6,
      "stimulusAids": [{"type":"placeValueBlocks","data":{"thousands":5,"hundreds":2,"tens":3,"ones":0,"highlightColumn":"thousands","showLabels":true,"showTotal":false},"a11y":{"alt":"MAB-blokjes: 5 duizendtallen, 2 honderdtallen, 3 tientallen, 0 eenheden — duizendtallen gemarkeerd"}}],
      "feedback": {
        "explanationText": "Kijk naar het getal 5.230. Begin rechts en tel de plekken: 0 (eenheden), 3 (tientallen), 2 (honderdtallen), 5 (duizendtallen). De 5 staat op de duizendtallenplek: 5 × 1.000 = 5.000.",
        "solutionSteps": [
          "Schrijf het getal op: 5.230",
          "Begin rechts en tel de plekken: 0 → eenheden, 3 → tientallen, 2 → honderdtallen, 5 → duizendtallen",
          "De 5 staat op de duizendtallenplek",
          "Bereken de waarde: 5 × 1.000 = 5.000"
        ],
        "distractorExplanations": {
          "0": "Goed! De 5 staat op de duizendtallenplek: 5 × 1.000 = 5.000.",
          "1": "Je hebt de 5 op de honderdtallenplek gezet: 5 × 100 = 500. Maar in 5.230 staat de 5 op de duizendtallenplek — de 4e plek van rechts. Onthoud: duizendtallen = 4e plek van rechts.",
          "2": "Je hebt de 5 op de tientallenplek gezet: 5 × 10 = 50. Maar in 5.230 staat de 6 op de tientallenplek. De 5 staat op de duizendtallenplek: 5 × 1.000 = 5.000.",
          "3": "Je hebt het cijfer 5 als antwoord genomen. Maar een cijfer heeft een plek — en die plek bepaalt de waarde. De 5 staat op de duizendtallenplek: 5 × 1.000 = 5.000."
        }
      }
    },
    {
      "id": "GET-GROOT-POS-002",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "multiple_choice",
      "question": "In het getal 78.432 staat de 7 op de tienduizendtallen. Wat is de waarde van de 7?",
      "options": ["70.000","7.000","700","7"],
      "correctAnswer": 0,
      "conceptId": "place_value_ten_thousands",
      "variantIndex": 2,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 1 },
      "supportAids": [{"type":"placeValueBlocks","showWhen":"wrong","data":{"thousands":8,"hundreds":4,"tens":3,"ones":2,"highlightColumn":"thousands","showLabels":true,"showTotal":true}}],
      "group": 6,
      "stimulusAids": [{"type":"placeValueBlocks","data":{"thousands":8,"hundreds":4,"tens":3,"ones":2,"highlightColumn":"thousands","showLabels":true,"showTotal":false},"a11y":{"alt":"MAB-blokjes voor 78.432 — focus op de tienduizendtal-plek (los blokje boven de duizendtallen-stack)"}}],
      "feedback": {
        "explanationText": "De vraag zegt al: de 7 staat op de tienduizendtallenplek. Bereken de waarde: 7 × 10.000 = 70.000. Check: 70.000 + 8.000 + 400 + 30 + 2 = 78.432 ✓",
        "solutionSteps": [
          "De vraag geeft de plek: tienduizendtallen",
          "Bereken de waarde: 7 × 10.000 = 70.000",
          "Check: 70.000 + 8.000 + 400 + 30 + 2 = 78.432 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De 7 staat op de tienduizendtallenplek: 7 × 10.000 = 70.000.",
          "1": "Je hebt tienduizendtallen verward met duizendtallen. Duizendtallen = 7 × 1.000 = 7.000. Maar tienduizendtallen zijn 10× groter: 7 × 10.000 = 70.000.",
          "2": "Je hebt tienduizendtallen verward met honderdtallen. Honderdtallen = 7 × 100 = 700. Maar tienduizendtallen zijn veel groter: 7 × 10.000 = 70.000.",
          "3": "Je hebt het cijfer 7 als antwoord genomen. Maar de plek bepaalt de waarde. Op de tienduizendtallenplek geldt: 7 × 10.000 = 70.000."
        }
      }
    },
    {
      "id": "GET-GROOT-POS-003",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "multiple_choice",
      "question": "Wat is de waarde van de 3 in het getal 4.365?",
      "options": ["300","3.000","30","3"],
      "correctAnswer": 0,
      "conceptId": "place_value_hundreds",
      "variantIndex": 3,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "supportAids": [{"type":"placeValueBlocks","showWhen":"wrong","data":{"thousands":4,"hundreds":3,"tens":6,"ones":5,"highlightColumn":"hundreds","showLabels":true,"showTotal":true}}],
      "group": 6,
      "stimulusAids": [{"type":"placeValueBlocks","data":{"thousands":4,"hundreds":3,"tens":6,"ones":5,"highlightColumn":"hundreds","showLabels":true,"showTotal":false},"a11y":{"alt":"MAB-blokjes voor 4.365 — focus op de honderdtallenplek"}}],
      "feedback": {
        "explanationText": "Kijk naar het getal 4.365. Begin rechts en tel de plekken: 5 (eenheden), 6 (tientallen), 3 (honderdtallen), 4 (duizendtallen). De 3 staat op de honderdtallenplek: 3 × 100 = 300.",
        "solutionSteps": [
          "Schrijf het getal op: 4.365",
          "Begin rechts en tel de plekken: 5 → eenheden, 6 → tientallen, 3 → honderdtallen, 4 → duizendtallen",
          "De 3 staat op de honderdtallenplek",
          "Bereken de waarde: 3 × 100 = 300"
        ],
        "distractorExplanations": {
          "0": "Goed! De 3 staat op de honderdtallenplek: 3 × 100 = 300.",
          "1": "Je hebt de 3 op de duizendtallenplek gezet. Maar in 4.365 staat de 4 op de duizendtallenplek, niet de 3. De 3 staat op de honderdtallenplek: 3 × 100 = 300.",
          "2": "Je hebt de 3 op de tientallenplek gezet: 3 × 10 = 30. Maar in 4.365 staat de 6 op de tientallenplek. De 3 staat op de honderdtallenplek: 3 × 100 = 300.",
          "3": "Je hebt het cijfer 3 als antwoord genomen. Maar de plek bepaalt de waarde. De 3 staat op de honderdtallenplek: 3 × 100 = 300."
        }
      }
    },
    {
      "id": "GET-GROOT-POS-004",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "multiple_choice",
      "question": "In het getal 12.809 staat een 0. Op welke plek staat de 0?",
      "options": ["tientallen","eenheden","honderdtallen","duizendtallen"],
      "correctAnswer": 0,
      "conceptId": "place_value_zero",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "supportAids": [
        {"type":"placeValueBlocks","showWhen":"wrong","data":{"thousands":2,"hundreds":8,"tens":0,"ones":9,"highlightColumn":"tens","showLabels":true,"showTotal":false,"label":"Onderste 4 plekken van 12.809 — de tientallenplek (0) is gemarkeerd"}},
        {"type":"rule","showWhen":"wrong","data":{"title":"Nul als plaatshouder","content":"De 0 in 12.809 houdt de tientallenplek bezet. Tel van rechts: eenheden (9), tientallen (0), honderdtallen (8), duizendtallen (2), tienduizendtallen (1). De 0 staat op de tientallenplek.","icon":"lightbulb"}}
      ],
      "group": 6,
      "stimulusAids": [{"type":"placeValueBlocks","data":{"thousands":2,"hundreds":8,"tens":0,"ones":9,"showLabels":true,"showTotal":false},"a11y":{"alt":"MAB-blokjes voor de onderste 4 plekken van 12.809 (de 1 tienduizendtal niet getoond) — 2 duizendtallen, 8 honderdtallen, 0 tientallen, 9 eenheden"}}],
      "feedback": {
        "explanationText": "Kijk naar het getal 12.809. Begin rechts en tel: 9 (eenheden), 0 (tientallen), 8 (honderdtallen), 2 (duizendtallen), 1 (tienduizendtallen). De 0 staat op de tientallenplek. De 0 houdt die plek bezet — er zijn 0 tientallen in dit getal.",
        "solutionSteps": [
          "Schrijf het getal op: 12.809",
          "Begin rechts en tel: 9 → eenheden, 0 → tientallen, 8 → honderdtallen",
          "De 0 staat op de tientallenplek",
          "De 0 is een plaatshouder: zonder de 0 zou je niet weten dat de 8 op de honderdtallenplek staat"
        ],
        "distractorExplanations": {
          "0": "Goed! De 0 staat op de tientallenplek in 12.809. Tel van rechts: 9 (eenheden), 0 (tientallen).",
          "1": "Je hebt de eenhedenplek gekozen. Maar op de eenhedenplek staat de 9, niet de 0. Begin rechts: het eerste cijfer (9) = eenheden, het tweede cijfer (0) = tientallen.",
          "2": "Je hebt de honderdtallenplek gekozen. Maar op de honderdtallenplek staat de 8. Tel van rechts: 9 (eenheden), 0 (tientallen), 8 (honderdtallen). De 0 staat op de tientallenplek.",
          "3": "Je hebt de duizendtallenplek gekozen. Maar op de duizendtallenplek staat de 2. De 0 staat op de tientallenplek — de 2e plek van rechts."
        }
      }
    },
    {
      "id": "GET-GROOT-POS-005",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "multiple_choice",
      "question": "Welk getal heeft een 6 op de duizendtallenplek?",
      "options": ["16.245","61.245","1.625","162.450"],
      "correctAnswer": 0,
      "conceptId": "place_value_identify_number",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "supportAids": [
        {"type":"placeValueBlocks","showWhen":"wrong","data":{"thousands":6,"hundreds":2,"tens":4,"ones":5,"highlightColumn":"thousands","showLabels":true,"showTotal":false,"label":"Onderste 4 plekken van 16.245 — de duizendtallenplek (6) is gemarkeerd"}},
        {"type":"rule","showWhen":"wrong","data":{"title":"Duizendtallenplek vinden","content":"De duizendtallenplek is de 4e plek van rechts. In 16.245: eenheden (5), tientallen (4), honderdtallen (2), duizendtallen (6). Hier staat de 6 op de duizendtallenplek. ✓","icon":"lightbulb"}}
      ],
      "group": 6,
      "stimulusAids": [],
      "feedback": {
        "explanationText": "De duizendtallenplek is de 4e plek van rechts. Kijk bij 16.245: 5 (eenheden), 4 (tientallen), 2 (honderdtallen), 6 (duizendtallen). De 6 staat op de duizendtallenplek — dus 16.245 is het goede antwoord.",
        "solutionSteps": [
          "De duizendtallenplek is de 4e plek van rechts",
          "Kijk bij 16.245: 5 → eenheden, 4 → tientallen, 2 → honderdtallen, 6 → duizendtallen",
          "De 6 staat op de duizendtallenplek ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! In 16.245 staat de 6 op de duizendtallenplek: 16.245 = 10.000 + 6.000 + 200 + 40 + 5.",
          "1": "In 61.245 staat de 6 op de tienduizendtallenplek (6 × 10.000 = 60.000). Op de duizendtallenplek staat de 1. Onthoud: duizendtallen = 4e plek van rechts.",
          "2": "In 1.625 staat de 6 op de honderdtallenplek (6 × 100 = 600). Op de duizendtallenplek staat de 1. Onthoud: duizendtallen = 4e plek van rechts.",
          "3": "In 162.450 staat de 6 op de tienduizendtallenplek (6 × 10.000 = 60.000). Op de duizendtallenplek staat de 2. Onthoud: tel altijd van rechts — de 4e plek is de duizendtallenplek."
        }
      }
    },
    {
      "id": "GET-GROOT-POS-PVB-001",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "place_value_build",
      "question": "Bouw het getal 2.347 met plaats-waarde-blokken.",
      "options": [],
      "correctAnswer": 2347,
      "data": {
        "mode": "build_target",
        "target": 2347,
        "showRunningTotal": true
      },
      "conceptId": "place_value_build_2347",
      "variantIndex": 10,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Plaats-waarde opdelen",
            "content": "2.347 = 2 duizendtallen + 3 honderdtallen + 4 tientallen + 7 enen. Zet 2 duizendkubussen, 3 honderdplaten, 4 tienstaven en 7 eenheidsblokjes neer.",
            "icon": "lightbulb"
          }
        }
      ],
      "group": 6,
      "feedback": {
        "explanationText": "2.347 = 2 × 1.000 + 3 × 100 + 4 × 10 + 7 × 1 = 2.000 + 300 + 40 + 7 = 2.347.",
        "solutionSteps": [
          "2 duizendkubussen → 2.000",
          "3 honderdplaten → 300",
          "4 tienstaven → 40",
          "7 eenheidsblokjes → 7",
          "Totaal: 2.000 + 300 + 40 + 7 = 2.347 ✓"
        ]
      }
    },
    {
      "id": "GET-GROOT-POS-PVB-002",
      "familyId": "GET-GROOT-POS",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "skill": "positiestelsel",
      "subSkill": "groot_positiestelsel",
      "questionType": "multiple_choice",
      "question": "Welk getal zie je hier?",
      "options": ["1.528", "1.582", "1.852", "1.285"],
      "correctAnswer": 1,
      "conceptId": "place_value_read_1582",
      "variantIndex": 11,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "pedagogy": { "dok": 2 },
      "stimulusAids": [
        {
          "type": "placeValueBlocks",
          "showWhen": "always",
          "data": {
            "thousands": 1,
            "hundreds": 5,
            "tens": 8,
            "ones": 2,
            "showLabels": true,
            "showTotal": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "placeValueBlocks",
          "showWhen": "wrong",
          "data": {
            "thousands": 1,
            "hundreds": 5,
            "tens": 8,
            "ones": 2,
            "showLabels": true,
            "showTotal": true
          }
        }
      ],
      "group": 6,
      "feedback": {
        "explanationText": "Tel per kolom: 1 duizendkubus (1.000), 5 honderdplaten (500), 8 tienstaven (80), 2 enen (2). Samen: 1.000 + 500 + 80 + 2 = 1.582.",
        "solutionSteps": [
          "1 duizendkubus → 1.000",
          "5 honderdplaten → 500",
          "8 tienstaven → 80",
          "2 enen → 2",
          "Totaal: 1.582 ✓"
        ],
        "distractorExplanations": {
          "0": "1.528 heeft 2 tientallen en 8 enen. Hier zie je juist 8 tienstaven en 2 enen. Lees de blokken zorgvuldig per kolom.",
          "1": "Goed! 1.000 + 500 + 80 + 2 = 1.582.",
          "2": "1.852 zou 8 honderdplaten en 5 tienstaven hebben. Hier zijn het er 5 en 8. De volgorde D-H-T-E telt.",
          "3": "1.285 mist de juiste plaatsing. De duizendkubus staat eerst (1.000), daarna 5 honderdplaten (500), niet 2."
        }
      }
    }
  ]
}